import { fromRef } from '../observable/fromRef';
export function createObjectSnapshotChanges(query) {
    return function snapshotChanges() {
        return fromRef(query, 'value');
    };
}
//# sourceMappingURL=snapshot-changes.js.map


//////////////////
// WEBPACK FOOTER
// /Users/makebetter/Documents/sportsceneDash/~/angularfire2/database/object/snapshot-changes.js
// module id = ../../../../angularfire2/database/object/snapshot-changes.js
// module chunks = 4